import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import IncreaseButton from '../increaseButton';
import DecreaseButton from '../decreaseButton';
import './index.css';

/**
 * Increase decrease button set
 * Parameters (Props)::
 * @param function increase
 * @param function decrease
 * @param string mode
 */
export default class IncreaseDecreaseButtonSet extends React.PureComponent {
  render() {
    const { increase, decrease, mode } = this.props;
    return (
      <Button.Group
        vertical
        size="massive"
        className="increase-decrease-button-set"
      >
        <IncreaseButton onClick={increase} mode={mode} />
        <DecreaseButton onClick={decrease} mode={mode} />
      </Button.Group>
    );
  }
}

IncreaseDecreaseButtonSet.propTypes = {
  increase: PropTypes.func.isRequired,
  decrease: PropTypes.func.isRequired,
  mode: PropTypes.string,
};

IncreaseDecreaseButtonSet.defaultProps = {
  mode: null,
};
